import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material/';
import { AppBarTop, BotaoUser, PersistentDrawerLeft } from '@monorepo-web/components-library';
import {
  useAppDispatch,
  useAppSelector,
  useLogout,
  changePassword,
  fetchPreference,
  resetStateHelper,
  setStatusSenha,
  toggleRecalcular,
  resetCapaPDF,
} from '@monorepo-web/logic-extrato';
import { useIsMobile } from '@monorepo-web/utils';

import { MainContainer, DrawerHeader } from './style';

interface IProps {
  drawerwidth: number;
  ListaMenu: any;
  MenuRoutes: React.ReactNode;
  hasDisclaimer: boolean;
}

const MainComponent = ({ drawerwidth, ListaMenu, MenuRoutes, hasDisclaimer }: IProps) => {
  const [
    carteiraSelecionada,
    loadingTrocarSenha,
    trocarSenhaStatus,
    isLoadingMinimized,
    preferenceImagem,
    preferenceImagemAPI,
  ] = useAppSelector((state) => [
    state.preference.params.carteira,
    state.preference.loadingTrocarSenha,
    state.preference.trocarSenhaStatus,
    state.loadMinimized.isLoadingMinimized,
    state.preference.preferenceStyle.imagem,
    state.preference.preferenceStyle.imagemAPI,
  ]);
  const dispatch = useAppDispatch();

  const isMobile = useIsMobile();
  const [isDrawerLeftOpen, setIsDrawerLeftOpen] = React.useState(!isMobile);

  const handleLogout = useLogout(hasDisclaimer);

  const handleRecalcularParam = () => {
    dispatch(toggleRecalcular());
    dispatch(resetStateHelper());
    dispatch(resetCapaPDF());
  };

  const handleStatusOKTrocarSenha = () => {
    const emailLogin = localStorage.getItem('emailLogin');
    const password = localStorage.getItem('senhaLogin');
    if (typeof emailLogin === 'string' && typeof password === 'string') {
      dispatch(fetchPreference({ username: emailLogin, password }));
    }
    dispatch(setStatusSenha('none'));
  };

  const botaoUser = (
    <BotaoUser
      loadingTrocarSenha={loadingTrocarSenha}
      trocarSenhaStatus={trocarSenhaStatus}
      handleRecalcularParam={handleRecalcularParam}
      handleStatusOKTrocarSenha={handleStatusOKTrocarSenha}
      handleSubmitTrocarSenhaParam={(password: string) => dispatch(changePassword(password))}
      handleLogout={handleLogout}
    />
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBarTop
        drawerwidth={drawerwidth}
        isDrawerLeftOpen={isDrawerLeftOpen}
        setIsDrawerLeftOpen={setIsDrawerLeftOpen}
        BotaoUser={botaoUser}
      />
      <PersistentDrawerLeft
        drawerwidth={drawerwidth}
        ListaMenu={ListaMenu}
        disabled={isLoadingMinimized}
        carteiraSelecionada={carteiraSelecionada ?? ''}
        logo={{
          src: preferenceImagemAPI?.Logo,
          width: preferenceImagem?.LogoWidth,
          height: preferenceImagem?.LogoHeight,
        }}
        isDrawerLeftOpen={isDrawerLeftOpen}
        setIsDrawerLeftOpen={setIsDrawerLeftOpen}
      />
      <MainContainer open={isDrawerLeftOpen} drawerwidth={drawerwidth}>
        <>
          <DrawerHeader />
          {MenuRoutes}
        </>
      </MainContainer>
    </Box>
  );
};

export default MainComponent;
